// extracted by mini-css-extract-plugin
export default {"form-group":"LeftSideBar_form-group__dsw9F","container":"LeftSideBar_container__-HwTl","containerWithHeader":"LeftSideBar_containerWithHeader__9cR2u"};